import { render, staticRenderFns } from "./BuyDataPackage.vue?vue&type=template&id=6f86804d&scoped=true"
import script from "./BuyDataPackage.vue?vue&type=script&lang=js"
export * from "./BuyDataPackage.vue?vue&type=script&lang=js"
import style0 from "./BuyDataPackage.vue?vue&type=style&index=0&id=6f86804d&prod&lang=scss"
import style1 from "./BuyDataPackage.vue?vue&type=style&index=1&id=6f86804d&prod&lang=scss&scoped=true"
import style2 from "./BuyDataPackage.vue?vue&type=style&index=2&id=6f86804d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f86804d",
  null
  
)

export default component.exports